import { zSchema, schemes } from "@zeal/common";

const browserFileSchema =
  typeof File === "undefined" ? zSchema.any() : zSchema.instanceof(File);

export const postPartnerBusinessDocumentsParamsSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  ein_letter: browserFileSchema.nullable(),
  additional_documents: zSchema.array(browserFileSchema),
});

export interface IPostPartnerBusinessDocumentsParams {
  whiteLabelID: string;
  ein_letter: File | null;
  additional_documents: File[];
}

export const postPartnerBusinessDocumentsResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string(),
});

export type TPostPartnerBusinessDocumentsResponse = zSchema.infer<
  typeof postPartnerBusinessDocumentsResponseSchema
>;
